import usePrivateAxios from '@/common/api/usePrivateAxios'
import { useMutation } from '@tanstack/react-query'

interface UseCreatePublicCompanyLeadContactProps {
  publicCompanyLeadId?: string
  onSuccess?: () => void
  onError?: () => void
}

export const useCreatePublicCompanyLeadContact = ({
  publicCompanyLeadId,
  onSuccess,
  onError,
}: UseCreatePublicCompanyLeadContactProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['createPublicCompanyLeadContact'],
    mutationFn: async () => {
      const lead = {
        contacts_attributes: [{ _create: true }],
      }

      return privateAxios.put(`/funnel/public/leads/${publicCompanyLeadId}`, {
        lead,
      })
    },
    onSuccess,
    onError,
  })
}
